var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { space } from 'styled-system';
import { css, styled } from "../utils";
var StyledStatusTag = styled.div(function (_a) {
    var status = _a.status, _b = _a.theme, colors = _b.colors, fontWeights = _b.fontWeights, fontSizes = _b.fontSizes, space = _b.space, onClick = _a.onClick;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    background-color: ", ";\n    border-radius: 10px;\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 0.96px;\n    line-height: normal;\n    padding: 0.25rem ", ";\n    white-space: nowrap;\n    cursor: ", ";\n    text-transform: uppercase;\n  "], ["\n    display: inline-block;\n    background-color: ", ";\n    border-radius: 10px;\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 0.96px;\n    line-height: normal;\n    padding: 0.25rem ", ";\n    white-space: nowrap;\n    cursor: ", ";\n    text-transform: uppercase;\n  "])), colors.statusTag[status || 'completed'], status === 'completed' || status === 'active' ? colors.secondary : colors.primary, fontWeights.medium, fontSizes[1], space[2], onClick && 'pointer');
}, space);
var StatusTag = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(StyledStatusTag, __assign({ "data-component": "StatusTag" }, props), children));
};
export default StatusTag;
var templateObject_1;
//# sourceMappingURL=StatusTag.js.map